import { render, staticRenderFns } from "./MeasureList.vue?vue&type=template&id=812f9e1a"
import script from "./MeasureList.vue?vue&type=script&lang=ts"
export * from "./MeasureList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports